export default {
    processing: false,
    cart: [],
    cartTotals: [],
    gateways: [],
    gatewaysMinValues: [],
    publicKey: "",
    voucher: "",
    isVoucherValid: false
};